// Gets the last object in an array where a given key
// matches a given value.
export default function getOneByProp (array, key, value) {
  let returnObj = null
  array.forEach(obj => {
    if (obj[key] === value) {
      returnObj = obj
    }
  })
  return returnObj
}


// WEBPACK FOOTER //
// ./src/helpers/users/getOneByProp.js